@if (isSelectedAttachmentsLoading()) {
  <app-loader></app-loader>
} @else {
  <div class="section-title" i18n="@@slide-overlay-delivery-items.productsummary">
    Product summary
  </div>

  @if (selectedItems()?.length) {
    <app-extended-quantity-summary-table
      [isSearchEnabled]="false"
      [isPaginatorEnabled]="false"
      [selectedItems]="selectedItems()"
      [isInboundShared]="isInboundShared()"
      [inboundSharedSenderOrgId]="inboundSharedSenderOrgId()"
      [columns]="['productName', 'materialNames', 'totalQuantity', 'materialData']"
    ></app-extended-quantity-summary-table>
  } @else {
    <div class="container-flex-center">
      <div class="info-hint font-size-unset" i18n="@@slide-overlay-delivery-items.summary.help">
        Once you add items to this delivery, a summary of their quantities will show up here
      </div>
    </div>
  }

  <div class="section-title mt-40" i18n="@@slide-overlay-delivery-items.selecteditems">
    Selected items
  </div>

  <section>
    <app-table
      [columnDefs]="itemsColumnDefs()"
      [isLoading]="isSelectedAttachmentsLoading()"
      [isRecordStateFilterEnabled]="false"
      [rowData]="itemRowData"
      [isPaginatorEnabled]="!overlay.contentRightSidePanel()"
    ></app-table>
  </section>

  @if (!isReadOnly) {
    <ng-template #attachmentsRightMenu>
      <app-right-side-panel
        [itemTypePlural]="translations.items"
        [isLoadingItems]="isLoadingItems()"
        [availableItems]="availableItems()"
        [addMenu]="menu"
        [isAdvancedSearch]="true"
        (pressAdd)="onAddNewItem()"
        (pressAddAll)="onAddAll()"
        class="overlay-right-panel"
        (pressRefresh)="reloadItems.emit()"
      >
        <app-advanced-search-items
          advanced-search
          [allProducts]="allProducts"
          [allLocations]="allLocations"
          [initialSearch]="currentItemsAdvancedSearch()"
          (searchChanged)="reloadItems.emit($event)"
        ></app-advanced-search-items>

        <div class="items-container">
          @if (isLoadingItems()) {
            <app-loader></app-loader>
          } @else {
            @for (item of mapToItemDetails(availableItems()); track item.id) {
              <app-draggable-card (pressed)="onAdd(item.id)" [item]="item">
                <app-item-card-content [item]="item"></app-item-card-content>
              </app-draggable-card>
            }
          }
        </div>
      </app-right-side-panel>
    </ng-template>
  }
}

<mat-menu #menu class="dropdown-menu">
  <app-dropdown-menu>
    <app-dropdown-menu-item (pressed)="onAddNewItem()">
      <mat-icon>add</mat-icon>
      <ng-container i18n="@@action.addoneitem">Add one item</ng-container>
    </app-dropdown-menu-item>
    <app-dropdown-menu-item (pressed)="onOpenBulkAddItemsSlideOver()">
      <mat-icon>library_add</mat-icon>
      <ng-container i18n="@@action.addmultipleitems">Add multiple items</ng-container>
    </app-dropdown-menu-item>
  </app-dropdown-menu>
</mat-menu>
